var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36842 7.36842H10.1316V10.1316H7.36842V7.36842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36842 13.8158H10.1316V16.5789H7.36842V13.8158Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36842 20.2632H10.1316V23.0263H7.36842V20.2632Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9737 7.36842H25.7895V10.1316H11.9737V7.36842Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9737 13.8158H25.7895V16.5789H11.9737V13.8158Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9737 20.2632H25.7895V23.0263H11.9737V20.2632Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9417 29.2482C35.2528 31.4804 34.4711 36.3032 28.8555 37.7371C27.02 37.7843 12.9241 37.7568 6.10555 37.7371C3.8824 37.3234 -0.400557 35.0466 0.252776 29.2482C0.317815 29.035 0.398098 28.7832 0.489736 28.4958C1.32958 25.8613 3.12322 20.2348 2.87778 13.984C2.81944 11.2463 1.41944 2.7968 0 0H28.7583C30.3803 4.11031 32.7913 14.4293 30.347 24.5424L30.3722 24.5409L29.1358 29.2482H34.9417ZM26.5095 29.2482H11.7833C12.1139 33.7585 9.39166 35.1372 6.80555 35.1372C3.36389 34.5857 2.50833 31.5329 2.83889 29.4648C5.01667 23.241 5.40555 18.1595 5.38611 13.984C5.37055 10.6436 4.12222 4.9502 3.5 2.52106C11.0574 2.52762 26.3356 2.53681 26.9889 2.52106C27.6889 3.93915 28.35 7.79952 28.8361 12.7038C29.225 16.6272 27.8833 23.5824 27.1639 26.5696C27.1695 26.5698 27.1751 26.57 27.1808 26.5702L26.5095 29.2482Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.bb119a19.svg";
export { ForwardRef as ReactComponent };